import { useContext, useState } from "react";
import MDSpinner from "react-md-spinner";
import { AppContext } from "../../../Util/contexts/AppContext";

const ChangePasswordPage = ({ changeSettingsPage, setSuccessMessage }) => {
  const { userData, route, primaryColor, displayAuthenticationError } =
    useContext(AppContext);
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmNewPassword, setConfirmNewPassword] = useState("");
  const [changePasswordError, setChangePasswordError] = useState(null);
  const [changePasswordLoading, setChangePasswordLoading] = useState(false);

  const changePasswordHandler = async (e) => {
    e.preventDefault();
    if (newPassword !== confirmNewPassword) {
      return setChangePasswordError(
        "New Password and Confirm Password must match"
      );
    }

    setChangePasswordError(null);
    setChangePasswordLoading(true);
    fetch(`${route}/changepassword.webapi`, {
      method: "POST",
      headers: {
        Token: userData.Token,
        "Content-Type": "text/plain",
      },
      body: JSON.stringify({
        OldPassword: currentPassword,
        NewPassword: newPassword,
      }),
    })
      .then((response) => {
        if (response.status === 200) {
          return response.text();
        } else if (response.status === 401) {
          return displayAuthenticationError();
        } else {
          throw new Error();
        }
      })
      .then((response) => {
        if (response.includes("Password Updated.")) {
          setSuccessMessage("Password updated successfully");
          changeSettingsPage("Settings");
        } else {
          // Remove curly braces from message
          let result = response.replace("{", "");
          result = result.replace("}", "");
          setChangePasswordError(`${result}`);
          setChangePasswordLoading(false);
        }
      })
      .catch((error) => {
        console.log(error);
        setChangePasswordError(
          "Failed to update password. Please confirm that you have entered the correct current password."
        );
        setChangePasswordLoading(false);
      });
  };

  return (
    <div
      className="accountSettingsBodyWrapper"
      id="ChangePassword"
      key="ChangePassword"
    >
      <form
        className="accountSettingsCard accountSettingsBigCard"
        onSubmit={changePasswordHandler}
      >
        <h3 className="accountSettingsCardTitle">Change Password</h3>
        <p className="accountSettingsToggleDescription">
          Update the password you use to log in
        </p>
        <label htmlFor="currentPassword" className="standardLabel">
          Current Password
        </label>
        <input
          type="password"
          value={currentPassword}
          onChange={(e) => setCurrentPassword(e.target.value)}
          id="currentPassword"
          autofill="current-password"
          className="standardInput"
        />
        <label htmlFor="newPassword" className="standardLabel">
          New Password
        </label>
        <input
          type="password"
          value={newPassword}
          onChange={(e) => setNewPassword(e.target.value)}
          autofill="new-password"
          id="newPassword"
          className="standardInput"
        />
        <label htmlFor="confirmNewPassword" className="standardLabel">
          Confirm New Password
        </label>
        <input
          type="password"
          value={confirmNewPassword}
          onChange={(e) => setConfirmNewPassword(e.target.value)}
          autofill="new-password"
          id="confirmNewPassword"
          className="standardInput"
        />
        {changePasswordError && (
          <p className="changePasswordErrorText">{changePasswordError}</p>
        )}
        <div className="accountSettingsButtonWrapper">
          <button
            className="secondaryButton"
            type="button"
            onClick={() => changeSettingsPage("Settings")}
          >
            Cancel
          </button>
          {changePasswordLoading ? (
            <div className="accountSettingsCardButtonLoaderContainer">
              <MDSpinner size={35} singleColor={primaryColor} />
            </div>
          ) : (
            <button
              className="accountSettingsButton tertiaryButton"
              type="submit"
            >
              Confirm
            </button>
          )}
        </div>
      </form>
    </div>
  );
};

export default ChangePasswordPage;
